export const RESET_DATA = 'RESET_DATA';

export const resetData = () => ({
    type: RESET_DATA
});
